import React from "react";
import axios from "axios";
import { useState } from "react";

function CalculateComp({ arr, id, language, onResponse }) {
  const initialFormData = arr.reduce(
    (acc, curr) => ({ ...acc, [curr]: "" }),
    [{}]
  );

  const [formData, setFormData] = useState(initialFormData);

  const handleSubmit = (e) => {
    e.preventDefault();
    axios
      .post(`${process.env.REACT_APP_API}api/v2/calculator`, {
        id: id,
        language: language,
        input: formData,
      })
      .then((res) => {
        console.log(res.data);
        onResponse(res.data);
      })
      .catch((err) => {
        console.log(err.message);
      });
  };
  const handleChange = (event) => {
    setFormData({
      ...formData,
      [event.target.name]: event.target.value,
    });
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="flex-col p-4 ">
        {arr.map((item, index) => {
          if (item["type"] == "select") {
            if (item["required"] == true) {
              return (
                <div className="flex-col" key={index}>
                  <div className="mt-2 text-[#000000] text-sm flex justify-start text-start font-montserrat font-semibold">
                    {item["title"]}
                    <div className="text-[#FF0000] ml-1">*</div>
                  </div>
                  <select
                    className="w-full  text-black py-1 pl-2 pr-4  border-[#000000C7] border-[0.5px] rounded-[5px] outline-0 bg-white font-montserrat text-xs"
                    name={item.name}
                    value={formData[item.name]}
                  >
                    {item["options"].map((item, index) => {
                      return (
                        <option value={item["key"]}>{item["label"]}</option>
                      );
                    })}
                  </select>
                </div>
              );
            } else {
              return (
                <div className="flex-col" key={index}>
                  <div className="mt-2 text-[#000000] text-sm flex justify-start text-start font-montserrat font-semibold">
                    {item["title"]}
                  </div>
                  <select className="w-full  text-black py-1 pl-2 pr-4  border-[#000000C7] border-[0.5px] rounded-[5px] outline-0 bg-white font-montserrat text-xs">
                    {item["options"].map((item, index) => {
                      return (
                        <option value={item["key"]}>{item["label"]}</option>
                      );
                    })}
                  </select>
                </div>
              );
            }
          } else {
            if (item["required"] == true) {
              return (
                <div className="flex-col" key={index}>
                  <div className="mt-2 text-[#000000] text-sm flex justify-start text-start font-montserrat font-semibold">
                    {item["title"]}
                    <div className="text-[#FF0000] ml-1">*</div>
                  </div>
                  <input
                    type={item["type"]}
                    onChange={handleChange}
                    placeholder={item["placeholder"]}
                    value={formData[item.name]}
                    name={item.name}
                    className="w-full focus:outline-none focus:border-sky-500 focus:ring-sky-500 focus:ring-1 text-black py-1 pl-2 pr-4  border-[#000000C7] border-[0.5px] rounded-[5px] outline-0 bg-white font-montserrat text-xs "
                  />
                </div>
              );
            } else {
              return (
                <div className="flex-col" key={index}>
                  <div className="mt-2 text-[#000000] text-sm flex justify-start text-start font-montserrat font-semibold">
                    {item["title"]}
                  </div>
                  <input
                    type={item["type"]}
                    name={item.name}
                    value={formData[item.name]}
                    onChange={handleChange}
                    placeholder={item["placeholder"]}
                    className="w-full  text-black py-1 pl-2 pr-4  border-[#000000C7] border-[0.5px] rounded-[5px] outline-0 bg-white font-montserrat text-xs "
                  />
                </div>
              );
            }
          }
        })}
        <div className="flex justify-center mt-4">
          <button
            className="bg-[#00C6CA] mr-6 w-2/5 text-white font-montserrat text-xs rounded-[5px] py-1 px-4"
            type="submit"
          >
            Calculate
          </button>
        </div>
      </div>
    </form>
  );
}

export default CalculateComp;
//
